export default {
    projectSchedules: {}
}
